/**
 * Query utility functions for search operations
 */

/**
 * Generates a unique search refresh ID for triggering force refreshes
 * @returns A UUID string for search refresh identification
 */
export function generateSearchRefreshId(): string {
  return crypto.randomUUID();
}

/**
 * Normalizes a query string by trimming whitespace
 * @param query - The raw query string
 * @returns The normalized query string
 */
export function normalizeQuery(query: string): string {
  return query.trim();
}

/**
 * Checks if two query strings normalize to the same value
 * @param queryA - First query string
 * @param queryB - Second query string
 * @returns True if both queries normalize to the same value
 */
export function areQueriesEquivalent(queryA: string, queryB: string): boolean {
  return normalizeQuery(queryA) === normalizeQuery(queryB);
}
